class HTMLImageSettingsElement extends HTMLElement {
    static ImageOrderName = 'data-media-order';

    static observedAttributes = [this.ImageOrderName];

    public get imageIndex(): string {
        return this.getAttribute('image-index');
    }

    public get getMediaType(): string {
        return this.getAttribute('data-media-type').toLocaleLowerCase();
    }

    public getModelName(typeName: string): string {
        const mediaType = this.getMediaType;
        if (mediaType == 'image')
            return `Images[${this.imageIndex}].${typeName}`;
        else if (mediaType == 'video')
            return `Videos[${this.imageIndex}].${typeName}`;
        else 
            return `Embeds[${this.imageIndex}].${typeName}`;
    }

    public get orderValue(): string {
        return this.getAttribute(HTMLImageSettingsElement.ImageOrderName);
    }

    public setOrderValue(order: any) {
        this.setAttribute(HTMLImageSettingsElement.ImageOrderName, order);
    }

    private AddPreviewImage(imageFile: File) {
        const preview: HTMLImageElement = this.querySelector('[data-type-image-preview]');
        preview.src = window.URL.createObjectURL(imageFile);
    }

    private AddPreviewVideo(previewFile: File) {
        const fileName = window.URL.createObjectURL(previewFile);

        const preview: HTMLVideoElement = this.querySelector('[data-type-video-preview]');
        preview.src = fileName;

        const previewSource: HTMLSourceElement = this.querySelector('[data-type-video-source]');
        previewSource.src = fileName;
    }

    public AddPreviewEmbed(url: string) {
        const preview: HTMLIFrameElement = this.querySelector('[data-type-embed-preview]');
        preview.src = url;

        const pathElement: HTMLInputElement = this.querySelector('[data-type-path]');
        pathElement.value = url;
    }

    public AddMediaPreview(previewFile: File) {
        if (this.getMediaType.toLocaleLowerCase() == 'image')
            this.AddPreviewImage(previewFile);
        else if (this.getMediaType.toLocaleLowerCase() == 'video')
            this.AddPreviewVideo(previewFile);
        const pathElement: HTMLInputElement = this.querySelector('[data-type-path]');
        pathElement.value = previewFile.name;
    }

    public get Deleted(): boolean {
        const deleteElement: HTMLInputElement = this.querySelector('[data-type-delete]');
        return deleteElement.checked;
    }

    private onMoveUp(ev: Event) {
        let searchForValidSibling = true;

        let order = Number(this.orderValue);
        let siblingOrder = order;
        let sibling: HTMLImageSettingsElement;
        while (order > 0 && searchForValidSibling) {
            order -= 1;
            
            sibling = document.querySelector(`[data-media-order='${order}']`);
            
            if (sibling == null)
                continue;

            if (sibling.Deleted)
                continue;
            
            searchForValidSibling = false;
            sibling.setOrderValue(siblingOrder);
            this.setOrderValue(order);
        }
    }

    private onMoveDown(ev: Event) {
        let searchForValidSibling = true;
        const siblingCount = this.parentElement.childElementCount;
        let order = Number(this.orderValue);
        let siblingOrder = order;
        let sibling: HTMLImageSettingsElement;
        while (order < siblingCount && searchForValidSibling) {
            order += 1;
            
            sibling = document.querySelector(`[data-media-order='${order}']`);
            
            if (sibling == null)
                continue;

            if (sibling.Deleted)
                continue;
            
            searchForValidSibling = false;
            sibling.setOrderValue(siblingOrder);
            this.setOrderValue(order);
        }
    }

    private onDeleteImage(ev: Event) {
       this.classList.add('d-none');
       const deleteCheckbox: HTMLInputElement = this.querySelector('[data-type-delete]')
       deleteCheckbox.value = 'true';

       this.parentElement.childNodes.forEach((el: HTMLImageSettingsElement) => {
            const elementOrder = Number(el.orderValue);

            if (Number(elementOrder) > Number(this.orderValue))
                el.setOrderValue(elementOrder - 1);
       });

       this.setOrderValue(-1);
    }

    connectedCallback() {
        // If parent element is not shown we assume its a template, so we dont chanage its values
        if (this.parentElement.classList.contains("d-none"))
            return;

        const mediaType = this.getMediaType;

        if (mediaType != 'image' && mediaType != 'video' && mediaType != 'embed') {
            console.debug('mediaType not set or invalid');
            return;
        }

        if (this.imageIndex == '?') {
            const mediaElementCount = document.querySelectorAll(`[data-media-type=${mediaType}]`);
            let newMediaIndex = 0;
            let media: number[] = [];
            mediaElementCount.forEach((x: HTMLImageSettingsElement) => {
                const mediaIndex = x.imageIndex;
                const mediaNumber = parseInt(mediaIndex);

                if (!Number.isNaN(mediaNumber)) {
                    media.push(Number(mediaIndex));
                }
            });

            if (media.length > 0) {
                newMediaIndex = (Math.max(...media) + 1);
            }

            this.setAttribute('image-index', newMediaIndex.toString());
        }

        this.setAttribute(HTMLImageSettingsElement.ImageOrderName, this.imageIndex);

        if (mediaType != 'embed') {
            const descriptionElement: HTMLInputElement = this.querySelector('[data-type-description]');
            descriptionElement.setAttribute('name', this.getModelName('Description'));
            
            const descriptionElementLabel: HTMLLabelElement = this.querySelector('[data-type-description-label]');
            descriptionElementLabel.setAttribute('for', this.getModelName('Description'));
            
            const creditElement: HTMLInputElement = this.querySelector('[data-type-credit]');
            creditElement.setAttribute('name', this.getModelName('Credit'));
    
            const creditElementLabel: HTMLLabelElement = this.querySelector('[data-type-credit-label]');
            creditElementLabel.setAttribute('for', this.getModelName('Credit'));
        }        
                
        const pathElement: HTMLInputElement = this.querySelector('[data-type-path]');
        pathElement.setAttribute('name', this.getModelName("Path"));

        const deleteElementLabel = this.querySelector('[data-type-delete-label]');
        deleteElementLabel.setAttribute('for', this.getModelName('Delete'));
        
        const deleteElement: HTMLInputElement = this.querySelector('[data-type-delete]');
        deleteElement.id = this.getModelName('Delete');
        deleteElement.name = this.getModelName('Delete');
        deleteElement.addEventListener("click", this.onDeleteImage.bind(this));
        
        const orderingElement: HTMLInputElement = this.querySelector('[data-type-ordering]');
        orderingElement.setAttribute('name', this.getModelName('Ordering'));
        
        const moveUpElement: HTMLButtonElement = this.querySelector('[data-type-ordering-up]');
        moveUpElement.addEventListener("click", this.onMoveUp.bind(this));

        const moveDownElement: HTMLButtonElement = this.querySelector('[data-type-ordering-down]');
        moveDownElement.addEventListener("click", this.onMoveDown.bind(this));

        let firstElement: HTMLImageSettingsElement = this;
        let lastElement: HTMLImageSettingsElement = this;

        this.parentElement.childNodes.forEach((el: HTMLImageSettingsElement) => {
            if (el != null && el instanceof HTMLImageSettingsElement && !el.Deleted) {

                if (Number(firstElement.orderValue) > Number(el.orderValue))
                    firstElement = el
                
                if (Number(lastElement.orderValue) < Number(el.orderValue))
                    lastElement = el;
                
                el.querySelector('[data-type-ordering-down]').classList.remove('d-none');
                el.querySelector('[data-type-ordering-up]').classList.remove('d-none');
            }
        });

        firstElement.querySelector('[data-type-ordering-up]').classList.add('d-none');
        lastElement.querySelector('[data-type-ordering-down]').classList.add('d-none');
    }

    disconnectedCallback() {
        const deleteElement: HTMLInputElement = this.querySelector('[data-type-delete]');
        deleteElement.id = this.getModelName('Delete');
        deleteElement.removeEventListener("click", this.onDeleteImage);

        const moveUpElement: HTMLButtonElement = this.querySelector('[data-type-ordering-up]');
        moveUpElement.removeEventListener("click", this.onMoveUp.bind(this));

        const orderDownElement: HTMLButtonElement = this.querySelector('[data-type-ordering-down]');
        orderDownElement.removeEventListener("click", this.onMoveDown.bind(this));
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name == 'data-media-order') {   
            const orderingElement: HTMLInputElement = this.querySelector('[data-type-ordering]');
            orderingElement.value = newValue;
            this.style.order = newValue;

            let imageCount = 0;

            this.parentElement.childNodes.forEach(((el: HTMLImageSettingsElement) => {
                if (el != null && !el.Deleted && el instanceof HTMLImageSettingsElement) 
                    imageCount += 1;
            }));

            if (newValue == '0')
                this.querySelector('[data-type-ordering-up]').classList.add('d-none');
            else
                this.querySelector('[data-type-ordering-up]').classList.remove('d-none');
            
            if (Number(newValue) == imageCount - 1)
                this.querySelector('[data-type-ordering-down]').classList.add('d-none');
            else
                this.querySelector('[data-type-ordering-down]').classList.remove('d-none');
                
        }
    }
}

customElements.define("st-media-settings", HTMLImageSettingsElement);